export default function CardValue({ icon, label, value }) {
  return (
    <div className="bg-white rounded-2xl shadow-md p-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-palette-indigo-muted text-palette-indigo-badge text-xl">
          {icon}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs text-palette-gray-secondary">{label}</div>
          <div className="text-2xl font-extrabold mt-1">{value}</div>
        </div>
      </div>
    </div>
  );
}
